import Icon from 'veui/components/Icon'
import { IconHamburger } from 'dls-icons-vue'

Icon.register('hamburger', IconHamburger)
